import { IToolbarConfig } from './typings';

const config: IToolbarConfig = {
  areas: undefined,
  styleName: 'normal',
  displayMode: undefined,
};

export default config;
